import { TwoFactorTargetEnv } from '@cbhq/two-factor-web/types';

import { shouldUseMocks } from ':support/utils/session-utils/shouldUseMocks';

// This function is used to get the target environment for the two factor web component
export function getTwoFactorTargetEnv(authEnvironment: string): TwoFactorTargetEnv {
  if (shouldUseMocks()) return TwoFactorTargetEnv.Mock;

  switch (authEnvironment) {
    case 'mock':
      return TwoFactorTargetEnv.Mock;
    case 'local':
      return TwoFactorTargetEnv.Local;
    case 'development':
      return TwoFactorTargetEnv.Development;
    case 'staging':
      return TwoFactorTargetEnv.Staging;
    case 'production':
      return TwoFactorTargetEnv.Production;
    default:
      throw new Error(`Invalid authEnvironment: ${authEnvironment}`);
  }
}
